/**
 * region for libraries*/
import React, { PureComponent } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class MessageModal extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            show: true
        }

        this.close = this.close.bind(this);
    }

    close() {
        this.setState({ show: false });
        this.props.onClose();
    }

    render() {

        const { show } = this.state;
        const { title, text, className } = this.props

        return (
            <Modal zIndex={9999} isOpen={show} toggle={this.close} className={className}>
                <ModalHeader toggle={this.close}>{title}</ModalHeader>
                <ModalBody className="text-center font-size-md">{text}</ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.close}>OK</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default MessageModal